import Bars from "./Bars.jsx";

export default Bars;



// WEBPACK FOOTER //
// ./src/components/common/treeTableWithSlider/bars/index.js